<template>
    <div class="web-body">
        <div class="web-header">
            <div class="web-1170">
                <img class="web-logo" :src="this.$api_url+'/static/images/logo.png'">
            </div>
        </div>
        <div class="web-nav">
            <div class="web-1170">
                <Header></Header>
            </div>
        </div>
        <div class="web-content">
            <div class="web-1170" style="height: 830px">
                <div class="web-list-left">
                    <h2>{{ title }}</h2>
                    <ul>
                        <li v-for="(item,index) in list" :key="index" :class="generateClassName(item.link)?'active':''"><a :href="item.link">{{ item.title }}</a></li>
                    </ul>
                </div>
                <div class="web-list-right">
                    <h2>{{ title }}</h2>
                    <ul>
                        <li v-for="(item,index) in content" :key="index">
                            <a :href="'/content/'+item.id">
                                <span class="left">{{ item.title }}</span>
                                <span class="right">{{ item.add_date }}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="web-footer">
            <div class="web-1170">
                <Footer></Footer>
            </div>
        </div>
    </div>
</template>

<script>
import("../../../public/css/web.css")
import Footer from "./footer"
import Header from "./header"

export default {
    name: "page_list",
    components: {Footer, Header},
    data() {
        return {
            title: "",
            list: [],
            content: [],
        };
    },
    // 监听属性
    computed: {},
    // 监控data数据变化
    watch: {},
    // 方法集合
    methods: {
        generateClassName(val) {
            if (val == this.$route.path) {
                return true
            } else {
                return false
            }
        },
        getList() {
            this.$api.get('/api/web/list-array/', {"url": this.$route.path}).then((response) => {
                this.title = response.title
                this.list = response.list
                this.content = response.content
                console.log(response)
            })
        }
    },
    // 生命周期 - 创建之前
    beforeCreate() {
    },
    // 生命周期 - 创建完成
    created() {
    },
    // 生命周期 - 挂载之前
    beforeMount() {
    },
    // 生命周期 - 挂载完成
    mounted() {
        this.getList()
    },
    // 生命周期 - 更新之前
    beforeUpdate() {
    },
    // 生命周期 - 更新之后
    updated() {
    },
}
</script>